"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var FormLabel_1 = __importDefault(require("../FormLabel"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: column;\n  position: relative;\n"], ["\n  display: ", ";\n  flex-direction: column;\n  position: relative;\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? 'flex' : 'inline-flex');
});
var Input = styled_components_1.default.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 3rem;\n  line-height: 3rem;\n  padding: ", ";\n  border: ", ";\n  background: rgba(255, 255, 255, 1);\n  border-radius: ", ";\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  width: 100%;\n  &:focus,\n  &:hover {\n    background: rgba(255, 255, 255, 1);\n    outline: ", ";\n  }\n  &:disabled {\n    background: rgba(220, 220, 220, 0.7);\n  }\n  ", ";\n"], ["\n  height: 3rem;\n  line-height: 3rem;\n  padding: ", ";\n  border: ", ";\n  background: rgba(255, 255, 255, 1);\n  border-radius: ", ";\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  width: 100%;\n  &:focus,\n  &:hover {\n    background: rgba(255, 255, 255, 1);\n    outline: ", ";\n  }\n  &:disabled {\n    background: rgba(220, 220, 220, 0.7);\n  }\n  ", ";\n"])), function (_a) {
    var icon = _a.icon;
    return (icon ? '0 0.75rem 0 3.25rem' : '0 0.75rem');
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return error.length > 0
        ? "1px solid " + theme.colors.error
        : "1px solid " + theme.colors.inputBorderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.misc.inputBorderRadius;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return error.length > 0 ? "1px solid " + theme.colors.error : "1px solid " + theme.colors.primary;
}, function (_a) {
    var isDirty = _a.isDirty;
    return isDirty && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:invalid {\n        border: ", ";\n      }\n    "], ["\n      &:invalid {\n        border: ", ";\n      }\n    "])), function (_a) {
        var theme = _a.theme;
        return "1px solid " + theme.colors.error;
    });
});
// const Label = styled.label`
//   font-weight: bold;
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   font-size: 0.8rem;
//   display: flex;
//   margin-bottom: 0.5rem;
//   color: ${({ theme }) => theme.colors.text};
//   display: flex;
//   align-items: center;
//   span {
//     text-transform: none;
//     font-weight: normal;
//     font-size: 0.8rem;
//     display: inline-flex;
//     margin-left: 1rem;
//     opacity: 0.8;
//   }
// `;
var Error = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n"], ["\n  color: ", ";\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n"])), function (props) { return props.theme.colors.error; });
var RelativeWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
// const ErrorIcon = styled(ErrorOutlineOutlinedIcon)`
//   position: absolute;
//   right: 1rem;
//   top: 50%;
//   transform: translateY(-50%);
//   path {
//     fill: ${props => props.theme.colors.error};
//   }
// `;
var StyledIconWrapper = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  left: ", ";\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: ", ";\n  svg path {\n    fill: ", ";\n  }\n"], ["\n  position: absolute;\n  left: ", ";\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: ", ";\n  svg path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var left = _a.left;
    return (left ? '0.75rem' : 'auto');
}, function (_a) {
    var left = _a.left;
    return (left ? 'auto' : '0.75rem');
}, function (_a) {
    var clickable = _a.clickable;
    return (clickable ? 'pointer' : 'default');
}, function (props) { return props.theme.colors.primary; });
var TextField = (0, react_1.forwardRef)(function (_a, ref) {
    var label = _a.label, _b = _a.hideLabel, hideLabel = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? '' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, 
    // multiline = false,
    id = _a.id, _e = _a.type, type = _e === void 0 ? 'text' : _e, className = _a.className, onChange = _a.onChange, _f = _a.required, required = _f === void 0 ? false : _f, _g = _a.requiredText, requiredText = _g === void 0 ? '*' : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h, _j = _a.placeholder, placeholder = _j === void 0 ? '' : _j, _k = _a.labelWeight, labelWeight = _k === void 0 ? '600' : _k, value = _a.value, icon = _a.icon, maxLength = _a.maxLength, defaultValue = _a.defaultValue, rest = __rest(_a, ["label", "hideLabel", "error", "fullWidth", "id", "type", "className", "onChange", "required", "requiredText", "disabled", "placeholder", "labelWeight", "value", "icon", "maxLength", "defaultValue"]);
    // const [inputValue, setInputValue] = useState<any>(value || '');
    var _l = (0, react_1.useState)(false), showAsText = _l[0], setShowAsText = _l[1];
    var _m = (0, react_1.useState)(false), isDirty = _m[0], setIsDirty = _m[1];
    var _o = (0, react_1.useState)(type), _type = _o[0], _setType = _o[1];
    var inputRef = (0, react_1.useRef)(null);
    var inputOnChange = function (e) {
        if (disabled)
            return;
        // setInputValue(e.target.value);
        if (onChange)
            onChange(e);
    };
    var valueProp = {};
    if (value)
        valueProp = { value: value };
    (0, react_1.useEffect)(function () {
        if (type === 'password') {
            _setType(showAsText ? 'text' : 'password');
            if (inputRef.current)
                inputRef.current.focus();
        }
    }, [showAsText]);
    return (react_1.default.createElement(Wrapper, { fullWidth: fullWidth },
        !hideLabel && (react_1.default.createElement(FormLabel_1.default, { htmlFor: id, weight: labelWeight },
            label,
            required && react_1.default.createElement("span", null, requiredText))),
        react_1.default.createElement(RelativeWrapper, null,
            react_1.default.createElement(Input, __assign({ isDirty: isDirty, icon: icon, ref: ref || inputRef, error: error, type: _type, id: id, className: className, onChange: inputOnChange, required: required, disabled: disabled, placeholder: placeholder, "aria-label": label, maxLength: maxLength, defaultValue: defaultValue, onFocus: function () { return setIsDirty(true); } }, valueProp, rest)),
            type === 'password' && (react_1.default.createElement(StyledIconWrapper, { clickable: true, onClick: function () { return setShowAsText(!showAsText); } }, showAsText ? 'Hide' : 'Show')),
            icon && error.length === 0 && type !== 'password' && (react_1.default.createElement(StyledIconWrapper, { left: true, clickable: false }, icon))),
        error && error.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Error, { className: "co-input-error" }, error)))));
});
exports.default = TextField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
